import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface AccountEntryResponse {
    transactionId?: number | string | null;
    traNo?: string | null;
    traType?: string | null;
    date?: string | null;
    accountNo?: string | null;
    traAmount?: string | number | null;
    balance?: string | number | null;
    amount?: string | number | null;
}

export const getAccountEntries = async (memberCode: string, partyType: "vendor" | "customer"): Promise<AccountEntryResponse[]> => {
    try {
        const response: ApiResponse<AccountEntryResponse[]> = (
            await apiClient.get("/transactions/account-entries", {
                params: { membercode: memberCode, party_type: partyType },
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch account entries");
    }
};
